import { Component, Inject, Output, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ResultsInvoice } from '../../interface/company-client.interface';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { MatSliderModule } from '@angular/material/slider';
import { FactoringOperationsService } from '../../service/factoring-operations.service';
import { FactoringCalculationRequest, FactoringCalculationResponse, NewInvoice } from '../../interface/invoice-operation.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { RegisterMinutesComponent } from '../register-minutes/register-minutes.component';
import { OperationAssociatedToMinuteVM, RegisterMinuteViewModel, RegisterMinuteWithOperationsVm } from '../../interface/company-minutes.interface';
import { RegisterMinuteWithOpsComponent } from '../register-minute-with-ops/register-minute-with-ops.component';
import { AuthService } from 'src/app/pages/authentication/service/auth.service';
import { SendNotification } from 'src/app/layouts/full/interface/headers.interface';
import { NotificationsService } from 'src/app/services/notifications.service';

@Component({
  selector: 'app-operation-modal',
  templateUrl: './operation-modal.component.html',
  styleUrls: ['./operation-modal.component.scss'],
})
export class OperationModalComponent {
  totalAmountInvoice: number = 0;
  totalAmountInvoiceCalculate: number = 0;
  dataInvoice: ResultsInvoice;
  rutUrl: number;
  sliderValue: number = 0;
  public isBuyOrderModified: boolean = false;
  public isCalculationRequired: boolean = true;

  /**
   * Guardado de calculo de operacion de factoring
   */
  public factoringCalculation: FactoringCalculationResponse | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ResultsInvoice,
    public dialogRef: MatDialogRef<OperationModalComponent>,
    private dialog: MatDialog,
    private service: FactoringOperationsService,
    private route: ActivatedRoute,
    private router: Router,
    private notification: NotificationsService,
    private authService: AuthService,
  ) {
    
    this.dataInvoice = data;
    this.totalAmountInvoice = data.totalAmount;
    this.totalAmountInvoiceCalculate = Math.round(
      this.totalAmountInvoice * 0.9
    );

    this.form.patchValue({
      sliderControl: this.totalAmountInvoiceCalculate,
    });
  }
  form = new FormGroup({
    sliderControl: new FormControl(0, ),
    rate: new FormControl<number | null>(0, [Validators.required, Validators.min(1)]),
    downPaymentPercentage: new FormControl<number | null>(0, [
      Validators.required,
      Validators.min(1),
      Validators.max(99)
    ]),
    operationalCost: new FormControl<number | null>(0, [Validators.required, Validators.min(1)]),

    comments: new FormControl<string | null>('', [Validators.required]),
    plazo: new FormControl<number | null>(0, [Validators.required, Validators.min(1)])
  });

  get f() {
    return this.form.controls;
  }
  updateSliderValue(event: any): void {
    const inputValue = event.target.value;
    this.form.get('sliderControl')?.setValue(inputValue);
  }

  ngOnInit() {

    this.route.queryParams.subscribe((params: any) => {
      const { client } = params;
      this.rutUrl = parseInt(client);
    });

    this.form.get('sliderControl')?.valueChanges.subscribe((value) => {
      // Realiza acciones específicas cuando cambia el valor del slider
      const downPaymentPercentage: number = parseFloat((value * 100 / this.totalAmountInvoice).toFixed(2));
    });
  }

  isValidToCalculate(): boolean{
    const hasRate = this.form.controls['rate'].valid;
    const hasPlazo = this.form.controls['plazo'].valid
    const hasOperationCost = this.form.controls['operationalCost'].valid;
    const hasDownPayment = this.form.controls['downPaymentPercentage'].valid;
    return hasRate && hasPlazo && hasOperationCost && hasDownPayment;
  }


  calculateOperation() {
    const hasRate = this.form.controls['rate'].valid;
    const hasPlazo = this.form.controls['plazo'].valid
    const hasOperationCost = this.form.controls['operationalCost'].valid;
    const hasDownPayment = this.form.controls['downPaymentPercentage'].valid;
    if(hasRate && hasPlazo && hasOperationCost && hasDownPayment){
      const calculationRequest: FactoringCalculationRequest = {
        invoiceId: this.data.invoiceId,
        invoiceTotalAmount: this.data.totalAmount,
        downPaymentPercentage: this.form.value.downPaymentPercentage,
        rate: this.form.value.rate,
        plazo: this.form.value.plazo,
        operationCost: this.form.value.operationalCost
      };

      this.service.calculateInvoiceOperation(calculationRequest)
      .subscribe({
        next: (response) => {
          this.factoringCalculation = response.value;
          this.isCalculationRequired = false;
        },
        error: (err) => {
          this.isCalculationRequired = true;
        }
      })
    }

  }

  isValueGreaterThanThreshold(): boolean {
    const sliderControl = this.form.get('sliderControl');
    const currentValue = sliderControl?.value;
    if (currentValue != null && currentValue > this.totalAmountInvoice) {
      sliderControl?.setErrors({ incorrect: true });
      return true; // El valor supera el umbral
    } else {
      sliderControl?.setErrors(null); // Reinicia los errores si el valor es válido
      return false;
    }
  }

  // ...

  onSliderChange(event: any): void {
    const sliderValue = this.form.get('sliderControl')!.value;
    this.form.get('sliderControl')?.setValue(sliderValue);
  }

  closeDialog() {
    this.dialogRef.close();
  }

  changeCalculationInput(){
    if(this.isCalculationRequired) return;
    this.factoringCalculation = null;
    this.isCalculationRequired = true;
  }
  alertNotification(action: string) {
    const id = parseInt(this.authService.getRutUser());
    const request: SendNotification = {
      action,
      companyId: this.rutUrl ,
      date: new Date(),
      userId: id,
      type: 1
    };  
    /*this.notification
      .createNotifications(request)
      .subscribe((a) => console.log(a));*/
  }

  submit() {
    const {allInRate, priceDifference, financedAmount, operationalCostTax, transferAmount} = this.factoringCalculation;
    const request: NewInvoice = {
      companyId: this.rutUrl,
      invoiceId: this.dataInvoice.invoiceId,
      financedAmount: financedAmount,
      rate: this.form.value.rate,
      allInRate: allInRate,
      downPaymentPercentage: this.form.value.downPaymentPercentage,
      priceDifference: priceDifference,
      operationalCost: this.form.value.operationalCost,
      operationalCostTax: operationalCostTax,
      transferAmount: transferAmount,
      comments: this.form.value.comments,
      plazo: this.form.value.plazo
    };
    Swal.fire({
      text: 'Se estan enviados los datos ingresados',
      icon: 'info',
      timerProgressBar: true,

      didOpen: () => {
        Swal.showLoading();
        this.service.newInvoice(request).subscribe({
          next: (res) => {
            Swal.fire({
              title: 'Minuta',
              text: '¿Requiere una minuta?',
              icon: 'warning',
              showCancelButton: false,
              showDenyButton: true,

              cancelButtonColor: '#198754',
              confirmButtonColor: '#3f51b5',
              denyButtonColor: '#424660',
              confirmButtonText: 'Si',
              cancelButtonText: 'Borrador',
              denyButtonText: `No`,
            }).then((r) => {
              if (r.isConfirmed) {
                const operationToAssociateToMinute: OperationAssociatedToMinuteVM = {
                  invoiceOperationId: res.invoiceOperationId,
                  folio: res.folio,
                  financedAmount: res.financedAmount,
                  fechaCesion: res.fechaCesion,
                  transferAmount: res.transferAmount
                };
                this.openViewRegisterMinutes(operationToAssociateToMinute);
                this.alertNotification("Minuta Creada")
              
                // Swal.fire('Minuta en Evaluación');
    //this.registerFactoringOperationMinute(res.invoiceOperationId);
                // this.router.navigate(['dashboards/minutes'], {
                //   queryParams: { client: +this.rutUrl },
                // });
              } else if (r.isDenied) {
                Swal.fire('Operacion Creada');
              this.isBuyOrderModified = true;
              this.alertNotification("Operacion Creada")

              } else if (r.isDismissed) {
                Swal.fire('Borrador Creado');
              }

              this.dialogRef.close(this.isBuyOrderModified);
            });
          },
          error: (err) => {
            Swal.fire({
              title: 'Error',
              text: 'Ha ocurrido un error ',
              icon: 'error',
            });
          },
        });
      },
    });
  }

  public openViewRegisterMinutes(operation: OperationAssociatedToMinuteVM) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.width = '70vw';
    dialogConfig.height = 'auto';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '90vh';
    const viewModel : RegisterMinuteWithOperationsVm = {
      clientCompanyId: this.rutUrl,
      operations: [operation]
    };
    dialogConfig.data = viewModel;
  
    const dialogRef = this.dialog.open(RegisterMinuteWithOpsComponent, dialogConfig);

    //dialogRef.afterClosed().subscribe((res: boolean) => {
    //  if (res) this.getMinutes(this.rutUrl);
    //});
  }


}
